import React from "react";
import { getFestiveFocus, NAVRATRI_DAYS } from "./navratriSeason";
import "./festive-theme.css";

const MOTE_SPOTS = [
  { top: "18%", left: "62%" },
  { top: "28%", left: "78%" },
  { top: "14%", left: "88%" },
  { top: "40%", left: "70%" },
  { top: "48%", left: "90%" },
  { top: "22%", left: "54%" },
  { top: "58%", left: "82%" },
  { top: "33%", left: "94%" },
];

const PETAL_SPOTS = [
  { left: "64%", delay: "0s", duration: "17s" },
  { left: "74%", delay: "4s", duration: "19s" },
  { left: "83%", delay: "8s", duration: "16s" },
  { left: "91%", delay: "2s", duration: "21s" },
  { left: "69%", delay: "11s", duration: "18s" },
];

const GARLAND = [
  { x: 36, y: 28, tone: "gold" },
  { x: 78, y: 42, tone: "deep" },
  { x: 120, y: 24, tone: "gold" },
  { x: 162, y: 46, tone: "deep" },
  { x: 204, y: 22, tone: "gold" },
  { x: 246, y: 40, tone: "deep" },
  { x: 288, y: 26, tone: "gold" },
  { x: 330, y: 44, tone: "deep" },
  { x: 372, y: 24, tone: "gold" },
];

function Marigold({ x, y, tone }) {
  const outer = tone === "deep" ? "#E25A12" : "#F0B429";
  const mid = tone === "deep" ? "#FFD0A4" : "#FFE7A3";
  return (
    <g transform={`translate(${x} ${y})`}>
      <path d="M-3 -16 C-12 -26 -1 -8 0 -6 C1 -8 12 -26 3 -16 C4 -8 1 -5 0 -6 C-1 -5 -4 -8 -3 -16Z" fill="#24663A" />
      <path d="M6 -12 C14 -20 8 -6 5 -4" fill="#1C4E2C" />
      {[0, 51, 102, 153].map((deg) => (
        <ellipse key={deg} cx="0" cy="8" rx="9" ry="4.4" fill={outer} transform={`rotate(${deg} 0 8)`} />
      ))}
      <circle cx="0" cy="8" r="4.2" fill={mid} />
      <circle cx="0" cy="8" r="1.7" fill="#6B2A0C" />
    </g>
  );
}

function Diya() {
  return (
    <span className="festive-diya">
      <svg viewBox="0 0 64 72" aria-hidden="true">
        <g className="festive-flame">
          <ellipse cx="32" cy="16" rx="7" ry="13" fill="#FFE08A" />
          <ellipse cx="32" cy="15" rx="3.2" ry="8" fill="#FFF8E4" />
        </g>
        <path d="M10 42c6 16 38 16 44 0-2 12-10 18-22 18S12 54 10 42z" fill="#9E2A24" />
        <path d="M16 42c5 9 27 9 32 0" fill="none" stroke="#F6E2A8" strokeWidth="1.4" />
        <path d="M30 40c1 6 3 6 4 0" fill="none" stroke="#FFE08A" strokeWidth="1.2" />
      </svg>
    </span>
  );
}

export default function FestiveHeroLayer() {
  const night = getFestiveFocus().day.hex;

  return (
    <div className="festive-hero" style={{ "--festive-night": night }} aria-hidden="true">
      <div className="festive-hero-wash" />
      <div className="festive-toran">
        <svg className="festive-garland" viewBox="0 0 408 78">
          <defs>
            <linearGradient id="festive-thread" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="#F6E2A8" stopOpacity="0" />
              <stop offset="0.15" stopColor="#F6E2A8" />
              <stop offset="0.5" stopColor="#E8B34A" />
              <stop offset="0.85" stopColor="#F6E2A8" />
              <stop offset="1" stopColor="#F6E2A8" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d="M4 10 C 70 22, 140 2, 204 12 S 330 24, 404 8" fill="none" stroke="url(#festive-thread)" strokeWidth="2.4" />
          {GARLAND.map((flower) => (
            <Marigold key={flower.x} x={flower.x} y={flower.y} tone={flower.tone} />
          ))}
        </svg>
      </div>
      {MOTE_SPOTS.map((spot, index) => (
        <span
          key={`${spot.top}-${spot.left}`}
          className="festive-mote"
          style={{ top: spot.top, left: spot.left, animationDelay: `${index * 0.35}s` }}
        />
      ))}
      {PETAL_SPOTS.map((petal) => (
        <span
          key={petal.left}
          className="festive-petal-fall"
          style={{ left: petal.left, animationDelay: petal.delay, animationDuration: petal.duration }}
        />
      ))}
      <div className="festive-diyas">
        <Diya />
        <Diya />
        <Diya />
      </div>
      <div className="festive-silk">
        {NAVRATRI_DAYS.map((day) => (
          <span key={day.id} style={{ background: day.hex }} />
        ))}
        <span className="festive-silk-dasara" />
      </div>
    </div>
  );
}
